export default __webpack_public_path__ + "static/media/button-small-inactive@3x.3e6fd55a.png";